import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import Index from "./pages/Index";
import ToolsPage from "./pages/ToolsPage";
import SolarCalculatorPage from "./pages/tools/SolarCalculatorPage";
import ShingleExplorerPage from "./pages/tools/ShingleExplorerPage";
import DesignEyeQPage from "./pages/tools/DesignEyeQPage";
import TotalProtectionPage from "./pages/tools/TotalProtectionPage";
import DesignInspirePage from "./pages/tools/DesignInspirePage";
import EstimateCalculatorPage from "./pages/tools/EstimateCalculatorPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import LandingPage from "./pages/LandingPage";
import RoofingPage from "./pages/services/RoofingPage";
import ConstructionPage from "./pages/services/ConstructionPage";
import SolarPage from "./pages/services/SolarPage";
import MoldRemediationPage from "./pages/services/MoldRemediationPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/get-estimate" element={<LandingPage />} />
            <Route path="/services/roofing" element={<RoofingPage />} />
            <Route path="/services/construction" element={<ConstructionPage />} />
            <Route path="/services/solar" element={<SolarPage />} />
            <Route path="/services/mold-remediation" element={<MoldRemediationPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tools/solar-calculator" element={<SolarCalculatorPage />} />
            <Route path="/tools/shingle-explorer" element={<ShingleExplorerPage />} />
            <Route path="/tools/design-eyeq" element={<DesignEyeQPage />} />
            <Route path="/tools/total-protection" element={<TotalProtectionPage />} />
            <Route path="/tools/design-inspire" element={<DesignInspirePage />} />
            <Route path="/tools/estimate-calculator" element={<EstimateCalculatorPage />} />
            {/* Legacy redirects */}
            <Route path="/solar-calculator" element={<SolarCalculatorPage />} />
            <Route path="/roof-visualizer" element={<ToolsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
